type TUserPosition = {
  lat: number;
  lng: number;
};

const getUserPosition = (): Promise<TUserPosition | null> =>
  new Promise<TUserPosition | null>((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude: lat, longitude: lng } = position.coords;
        resolve({ lat, lng });
      },
      () => resolve(null)
    );
  });
export default getUserPosition;
